// extracted by mini-css-extract-plugin
export default {"message":"_2hv0f","countdown":"_1oxNA","countdown-value":"_1ckl7","countdownValue":"_1ckl7","countdown-ended":"DEwye","countdownEnded":"DEwye"};